import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { ThreeColumnBlockType } from '@appTypes/ThreeColumnBlockType';
import { MainEntries } from '@components/SectionBlocks/blocks/ThreeColumnBlock';

export interface ThreeColumnBlockSerializerProps {
  node: ThreeColumnBlockType;
}

export const ThreeColumnBlock = ({ node }: ThreeColumnBlockSerializerProps) => (
  <div className="threeColumnBlock">
    {node.title && <Text variant={TextVariant.Header2}>{node.title}</Text>}
    {node.mainEntries && <MainEntries mainEntries={node.mainEntries} />}
  </div>
);
